/* OddDrop native cart.note. Free text stays in Shopify; never send it to analytics/storage. */
(function () {
  'use strict';
  if (window.OddOrderNote) return;
  var initialized = false, draft = '', saved = '';
  var pending = null, timer = null, state = 'idle';
  var replayClicks = new WeakSet(), replayForms = new WeakSet(), gated = new WeakSet();
  var messages = { idle: '', dirty: 'Not saved yet.', saving: 'Saving…', saved: 'Saved with your cart.', error: 'Could not save. Please try again before checkout.' };
  function inputs() { return Array.prototype.slice.call(document.querySelectorAll('[data-order-note-input]')); }
  function fit(field) {
    // Closed disclosures and hidden drawers have no usable width. Resize on opening.
    if (!field.getClientRects().length || !field.clientWidth) return;
    field.style.height = 'auto';
    field.style.height = (field.scrollHeight + field.offsetHeight - field.clientHeight) + 'px';
  }
  function fitAll() { inputs().forEach(fit); }
  function rootUrl() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function paint(next) {
    state = next || state;
    document.querySelectorAll('[data-order-note]').forEach(function (box) {
      box.setAttribute('data-save-state', state);
      var status = box.querySelector('[data-order-note-status]');
      if (status) status.textContent = messages[state];
      var button = box.querySelector('[data-order-note-save]');
      if (button) { button.disabled = state === 'saving'; button.textContent = state === 'saving' ? 'Saving…' : 'Save note'; }
    });
  }
  function sync(source) {
    var fields = inputs();
    if (!initialized && fields.length) { draft = saved = fields[0].value; initialized = true; }
    if (!initialized) return;
    fields.forEach(function (field) { if (field !== source && field.value !== draft) field.value = draft; fit(field); });
    paint();
  }
  function needsSave() { return initialized && (draft !== saved || !!pending); }
  function flush() {
    clearTimeout(timer); timer = null;
    if (pending) return pending.then(flush);
    if (!initialized || draft === saved) { if (initialized) paint(saved ? 'saved' : 'idle'); return Promise.resolve(); }
    var value = draft;
    var controller = window.AbortController ? new AbortController() : null;
    var deadline = controller ? setTimeout(function () { controller.abort(); }, 12000) : null;
    paint('saving');
    pending = fetch(rootUrl() + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ note: value }), signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error('note_save_failed');
      return response.json();
    }).then(function (cart) {
      if (String(cart.note || '').replace(/\r\n/g, '\n') !== value.replace(/\r\n/g, '\n')) throw new Error('note_not_confirmed');
      saved = value;
      paint(draft === saved ? 'saved' : 'dirty');
    }).catch(function () {
      paint('error');
      throw new Error('note_save_failed'); // Do not echo API errors or customer text.
    }).finally(function () { clearTimeout(deadline); pending = null; });
    return pending.then(function () { if (draft !== saved) return flush(); });
  }
  function saveQuietly() { return flush().catch(function () {}); }
  function showProblem() {
    document.querySelectorAll('[data-order-note]').forEach(function (box) { box.open = true; });
    var field = inputs().find(function (input) { return input.getClientRects().length; });
    if (field) field.focus({ preventScroll: false });
  }
  function continueAfterSave(target, action) {
    if (gated.has(target)) return;
    gated.add(target);
    flush().then(function () { action(); }).catch(function () { showProblem(); }).finally(function () { gated.delete(target); });
  }
  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-order-note-input]')) return;
    if (!initialized) sync();
    draft = event.target.value;
    sync(event.target); paint('dirty');
    clearTimeout(timer); timer = setTimeout(saveQuietly, 500);
  });
  document.addEventListener('change', function (event) { if (event.target.matches('[data-order-note-input]')) saveQuietly(); });
  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('[data-order-note-save]');
    if (target) { event.preventDefault(); saveQuietly(); return; }
    target = event.target.closest && event.target.closest('a[href], [data-buy-now], [data-focus-buy]');
    if (!target || event.defaultPrevented || event.button > 0) return;
    if (replayClicks.has(target)) { replayClicks.delete(target); return; }
    var checkout = target.matches('[data-buy-now], [data-focus-buy]');
    if (!checkout && target.tagName === 'A') {
      try { var url = new URL(target.href, location.origin); checkout = url.origin === location.origin && /\/(?:checkout)(?:\/|$)/.test(url.pathname); } catch (_) {}
    }
    if (!checkout || !needsSave()) return;
    // Preserve explicit new-tab/window navigation; do not replay it as a same-tab click.
    if (target.tagName === 'A' && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || (target.target && target.target !== '_self'))) {
      saveQuietly(); return;
    }
    event.preventDefault(); event.stopImmediatePropagation();
    continueAfterSave(target, function () { replayClicks.add(target); target.click(); });
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.id !== 'cart-form') return;
    if (replayForms.has(form)) { replayForms.delete(form); return; }
    if (!needsSave()) return;
    var submitter = event.submitter;
    event.preventDefault(); event.stopImmediatePropagation();
    continueAfterSave(form, function () { replayForms.add(form); form.requestSubmit(submitter || undefined); });
  }, true);
  window.addEventListener('pagehide', function () {
    // A last blur/navigation can happen before the debounce. Same-origin cart only.
    if (!initialized || draft === saved || pending) return;
    fetch(rootUrl() + 'cart/update.js', { method: 'POST', credentials: 'same-origin', keepalive: true,
      headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: draft }) }).catch(function () {});
  });
  document.addEventListener('toggle', function (event) {
    if (event.target.matches && event.target.matches('[data-order-note]') && event.target.open) fitAll();
  }, true);
  var resizeFrame = null;
  window.addEventListener('resize', function () {
    if (resizeFrame !== null) cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(function () { resizeFrame = null; fitAll(); });
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
  window.OddOrderNote = { flush: flush }; // No public accessor exposes free text to analytics.
  sync();
  new MutationObserver(function (records) {
    if (records.some(function (record) { return Array.prototype.some.call(record.addedNodes, function (node) {
      return node.nodeType === 1 && (node.matches('[data-order-note]') || node.querySelector('[data-order-note]'));
    }); })) sync();
  }).observe(document.body, { childList: true, subtree: true });
})();
